(function (angular) {
	'use strict';

	angular.module('alertModule', [
		'BaseConfig'
	]);
})(window.angular);